<template>
  <Box :background-class="backgroundClass" :add-shadow="false" class="p-2">
    <div :class="[textColorClass, 'flex', 'gap-2', 'items-center']">
      <div class="flex items-center">
        <Component
          :is="iconComponent"
          v-if="showIcon"
          class="shrink-0 h-4 w-4 self-start mt-0.5"
        />
      </div>
      <div class="font-normal flex-1 min-w-0">
        <slot>
          {{ text }}
        </slot>
      </div>
    </div>
  </Box>
</template>

<script lang="ts" setup>
import { computed, type Component, type ComputedRef, type PropType } from 'vue'
import UnknownIcon from '~/../member-webapp-shared/components/icons/UnknownIcon.vue'
import ThumbupIcon from '~/../member-webapp-shared/components/icons/streamline/ThumbupIcon.vue'
import Box from '~/../member-webapp-shared/components/common/Box.vue'
import ExclamationIcon from '~/../member-webapp-shared/components/icons/ExclamationIcon.vue'
import InformationCircleIcon from '~/../member-webapp-shared/components/icons/InformationCircleIcon.vue'

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  showIcon: {
    type: Boolean,
    default: true,
  },
  alertType: {
    type: String as PropType<'info' | 'warn' | 'question' | 'positive'>,
    default: 'info',
  },
})

const backgroundClass: ComputedRef<string> = computed(() => {
  switch (props.alertType) {
    case 'info':
      return 'bg-fp-blue-1'
    case 'warn':
      return 'bg-fp-red-2'
    default:
      return 'bg-fp-blue-1'
  }
})

const textColorClass: ComputedRef<string> = computed(() => {
  switch (props.alertType) {
    case 'info':
      return 'text-fp-blue-7'
    case 'warn':
      return 'text-fp-red-7'
    default:
      return 'text-fp-blue-7'
  }
})

const iconComponent: ComputedRef<Component> = computed(() => {
  switch (props.alertType) {
    case 'info':
      return InformationCircleIcon
    case 'warn':
      return ExclamationIcon
    case 'question':
      return UnknownIcon
    case 'positive':
      return ThumbupIcon
    default:
      return InformationCircleIcon
  }
})
</script>
